import { v2Request } from './client';

export const APP_UPDATE_DOC_ID = 'customer-app';

/**
 * Pilot app_updates metadata for Capgo OTA.
 * @returns {Promise<{ version: string, bundleUrl: string, releaseNotes?: string, releasedAt?: number } | null>}
 */
export async function getAppUpdateInfo() {
  const body = await v2Request(`/api/app-updates/${encodeURIComponent(APP_UPDATE_DOC_ID)}`);
  return body?.data ?? null;
}
